import * as _ from "lodash"
import {observer} from "mobx-react"
import React from "react"
import {
    Grid,
    Typography,
    TextField,
    FormControl,
    FormLabel,
    FormHelperText,
    Select,
    MenuItem,
    Checkbox,
    FormGroup,
    FormControlLabel,
    Container,
    Alert,
    AlertTitle,
    Card,
    CardContent,
    IconButton
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import {connect} from "react-redux"
import {RouteComponentProps} from "react-router"
import {Dispatch} from "redux"
import {isNullOrUndefined} from "util"
import {authStore} from "../../app/common/authentication/AuthStore"
import {productStore} from "../../app/common/products/ProductStore"
import {postProfileSuccess} from "../../redux/app/actions"
import ApiService from "../../services/ApiService"
import HelperService from "../../services/HelperService"
import {ApiErrorResponse, ApiPanelGraph, LastPage, Profile, State, Take, TestState} from "../../types/types"
import {SUPPORT_MESSAGE} from "../../util/Constants"
import {formString} from "../../util/elvis"
import {log} from "../../util/Logging"
import {validateEmail} from "../../util/validators"
import {TakeId} from "../../validation/ValidPrimaryKey"
import {addTakeDispatches, TakeDispatches} from "../App/App"
import Button from "../Button/Button"
import PlaceProfileConstants, {IProfileLanguage, IProfileTest} from "./PlaceProfileConstants"
import {placeProfileStore} from "./PlaceProfileStore"
import {contentAreaStore} from "../../app/common/contentArea/ContentAreaStore"

interface FormErrors {
    firstName: string[]
    lastName: string[]
    testTakerId: string[]
    confirmTestTakerId: string[]
    testTakerEmail: string[]
    testsTaken: string[]
    yearsStudyingOrSpoken: string[]
    gradesStudiedIn: string[]
    familySpeaksOtherLanguage: string[]
    familyLanguage: string[]
    familyMembers: string[]
    otherFamilyMember: string[]

    [key: string]: string[]
}

interface StateToProps {
    take: Take | null
    takeCode: string
    panelGraph: ApiPanelGraph
}

function mapStateToProps(state: State): StateToProps {
    return {
        take: state.app.take,
        takeCode: state.app.takeCode,
        panelGraph: state.app.panelGraph!
    }
}

interface DispatchToProps extends TakeDispatches {
    profileSuccessDispatch: (profile: Profile) => void
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    const dispatchs = {
        profileSuccessDispatch: (profile: Profile) => {
            dispatch(postProfileSuccess(profile))
        }
    }
    return addTakeDispatches(dispatchs, dispatch)
}

interface ComponentPropsType extends StateToProps, DispatchToProps, RouteComponentProps<{}> {
}

interface ComponentState {
    error: boolean | string
    profile: Profile
    apScore: string
    ibScore: string
    satiiScore: string
    stampScore: string
    opiScore: string
    wptScore: string
    opicScore: string
    take: Take | null
    showModal: boolean
    formErrors: FormErrors
    formError: string | null
    testsTaken: string[]
    confirmTestTakerId: string
    loaded: boolean
}

@observer
class PlaceProfileFormContainer extends React.Component<ComponentPropsType, ComponentState> {
    constructor(props: ComponentPropsType) {
        super(props)
        this.state = {
            error: false,
            profile: {
                firstName: props.take && props.take.profile ? props.take.profile.firstName : "",
                lastName: props.take && props.take.profile ? props.take.profile.lastName : "",
                testTakerId: props.take && props.take.profile ? props.take.profile.testTakerId : "",
                testTakerEmail: props.take && props.take.profile ? props.take.profile.testTakerEmail : "",
                yearsStudyingOrSpoken: props.take && props.take.profile ? props.take.profile.yearsStudyingOrSpoken : "",
                gradesStudiedIn: props.take && props.take.profile ? props.take.profile.gradesStudiedIn : [],
                testsTaken: props.take && props.take.profile ? props.take.profile.testsTaken : [],
                familySpeaksOtherLanguage:
                    props.take && props.take.profile ? props.take.profile.familySpeaksOtherLanguage : undefined,
                familyLanguage: props.take && props.take.profile ? props.take.profile.familyLanguage : -1,
                familyMembers: props.take && props.take.profile ? props.take.profile.familyMembers : [],
                otherFamilyMember: props.take && props.take.profile ? props.take.profile.otherFamilyMember : "",
                languageConfidence:
                    props.take && props.take.profile
                        ? props.take.profile.languageConfidence
                        : PlaceProfileConstants.grades[0],
                schoolName: props.take && props.take.profile ? props.take.profile.schoolName : "",
                testGroupName: props.take && props.take.profile ? props.take.profile.testGroupName : "",
                contentAreaId: props.panelGraph ? props.panelGraph.contentAreaId : -1,
                userId: authStore.auth!!.loginId ? authStore.auth!!.loginId!! : -1,
                takeCode: props.takeCode ? props.takeCode : "",
                selfEvaluationIndex: props.take && props.take.profile ? props.take.profile.selfEvaluationIndex : 0
            },
            confirmTestTakerId:
                props.take && props.take.profile && props.take.profile.testTakerId
                    ? props.take.profile.testTakerId
                    : "",
            formErrors: {
                firstName: [],
                lastName: [],
                testTakerId: [],
                confirmTestTakerId: [],
                testTakerEmail: [],
                testsTaken: [],
                yearsStudyingOrSpoken: [],
                gradesStudiedIn: [],
                familySpeaksOtherLanguage: [],
                familyLanguage: [],
                familyMembers: [],
                otherFamilyMember: []
            },
            formError: null,
            take: this.props.take,
            showModal: false,
            apScore: "",
            ibScore: "",
            satiiScore: "",
            stampScore: "",
            opiScore: "",
            wptScore: "",
            opicScore: "",
            testsTaken: [],
            loaded: false
        }
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this)
        this.handleLastNameChange = this.handleLastNameChange.bind(this)
        this.handleTestTakerIdChange = this.handleTestTakerIdChange.bind(this)
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.handleLanguageChange = this.handleLanguageChange.bind(this)
        this.handleYearsStudyingOrSpokenChange = this.handleYearsStudyingOrSpokenChange.bind(this)
        this.handleGradesStudiedInChange = this.handleGradesStudiedInChange.bind(this)
        this.handleTestsTakenChange = this.handleTestsTakenChange.bind(this)
        this.handleFamilySpeaksOtherLanguageChange = this.handleFamilySpeaksOtherLanguageChange.bind(this)
        this.handleFamilyMemberChange = this.handleFamilyMemberChange.bind(this)
        this.handleFamilyMemberOtherChange = this.handleFamilyMemberOtherChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.closeModal = this.closeModal.bind(this)

        PlaceProfileConstants.languages.sort((a: IProfileLanguage, b: IProfileLanguage) => {
            // Special case: Always sort "OTHER" to last position.
            if (a.name === "OTHER") {
                return 1
            }
            if (b.name === "OTHER" || a.name < b.name) {
                return -1
            }
            if (a.name > b.name) {
                return 1
            }
            return 0
        })
    }

    async componentDidMount() {
        HelperService.enableTextSelection()
        await this.getData()
    }

    async componentDidUpdate() {
        if (this.props.take !== this.state.take) {
            this.setState({take: this.props.take})
        }

        if (this.props.take && this.props.take.profile && this.props.take.profile !== this.state.profile) {
            const profile = this.props.take.profile
            profile.contentAreaId = this.state.profile.contentAreaId
            profile.userId = this.state.profile.userId
            profile.takeCode = this.state.profile.takeCode
            this.setState({profile})
        }

        await this.getData()
    }

    getData = async () => {
        const driver = productStore.driver
        const product = productStore.loginProduct
        const {takeCode, panelGraph} = this.props
        const {loaded} = this.state
        if (driver && !loaded) {
            this.setState({loaded: true})
            document.title = `${driver.config.PRODUCT_TITLE} | Profile`
            let lastPage: LastPage | null = HelperService.getLastPageFromLs()
            if (lastPage) {
                const testState: TestState = await driver.helper.refreshTest(this.props, lastPage, product!)
                if (!testState.take) {
                    throw Error("testState.take is null or undefined")
                }
                if (!testState.take.profile) {
                    throw Error("testState.take.profile is null or undefined")
                }

                testState.take.profile.contentAreaId = this.props.panelGraph.contentAreaId
                testState.take.profile.userId = authStore.auth!!.loginId ? authStore.auth!!.loginId!! : -1
                testState.take.profile.takeCode = this.props.takeCode

                this.setState({
                    confirmTestTakerId:
                        testState.take && testState.take.profile && testState.take.profile.testTakerId !== undefined
                            ? testState.take.profile.testTakerId
                            : ""
                })

                this.setState({take: testState.take, profile: testState.take.profile})
            } else {
                lastPage = {
                    url: "/place-profile",
                    takeCode,
                    panelGraphId: panelGraph.id
                }
                localStorage.setItem("lastPage", JSON.stringify(lastPage))
            }
        }
    }

    handleFirstNameChange(e: any) {
        const profile: Profile = this.state.profile
        profile.firstName = formString(e.target.value, "")
        this.setState({profile})
    }

    handleLastNameChange(e: any) {
        const profile: Profile = this.state.profile
        profile.lastName = e.target.value
        this.setState({profile})
    }

    handleTestTakerIdChange(e: any) {
        const profile: Profile = this.state.profile
        profile.testTakerId = e.target.value
        this.setState({profile})
    }

    handleConfirmTestTakerIdChange = (e: any) => {
        this.setState({confirmTestTakerId: e.target.value})
    }

    handleEmailChange(e: any) {
        const profile: Profile = this.state.profile
        profile.testTakerEmail = e.target.value
        this.setState({profile})
    }

    handleLanguageChange(e: any) {
        const profile: Profile = this.state.profile
        profile.familyLanguage = e.target.value
        this.setState({profile})
    }

    handleYearsStudyingOrSpokenChange(e: any) {
        const profile: Profile = this.state.profile
        profile.yearsStudyingOrSpoken = e.target.value
        this.setState({profile})
    }

    handleProficiencyChange = (e: any) => {
        const profile: Profile = this.state.profile
        profile.languageConfidence = e.target.value
        this.setState({profile})
    }

    changHandlerForGradesStudied = (value: string) => {
        this.handleGradesStudiedInChange(value)
    }

    handleGradesStudiedInChange(value: string) {
        const profile: Profile = this.state.profile
        const gradesStudiedIn: string[] = placeProfileStore.gradesStudied
        const index: number = gradesStudiedIn.indexOf(value)
        const noneValue: string = "None"

        // If the option just clicked is None...
        if (value === noneValue) {
            // Reset the list to contain only None.
            gradesStudiedIn.length = 0
            gradesStudiedIn.push(value)
        } else {
            // If the option just clicked is already in the list...
            if (index > -1) {
                // It is being de-selected; remove it from the list.
                gradesStudiedIn.splice(index, 1)
            } else {
                // It is being selected; add it to the list.
                gradesStudiedIn.push(value)
                // If the None option is in the list, remove it.
                const indexOfNone: number = gradesStudiedIn.indexOf(noneValue)
                if (indexOfNone > -1) {
                    gradesStudiedIn.splice(indexOfNone, 1)
                }
            }
        }

        profile.gradesStudiedIn = gradesStudiedIn
        this.setState({profile})
    }

    testsTakenCallBack = (value: string) => {
        const curVal: IProfileTest | null | undefined = _.find(PlaceProfileConstants.tests, (ttp) => ttp.name === value)
        if (curVal !== undefined && curVal !== null) {
            this.handleTestsTakenChange(curVal)
        }
    }

    handleTestsTakenChange(test: IProfileTest) {
        // List of items checked in child componenet
        const testsTaken: string[] = placeProfileStore.testsTaken

        // Find the index of the testtaken
        const index: number = testsTaken.indexOf(test.name)

        if (test.name !== "None") {
            const noneIndex: number = testsTaken.indexOf("None")
            const noneIndexDB: number = placeProfileStore.testsTakenDBName.indexOf("none")
            if (noneIndex > -1) {
                // Remove Refrence to none because a test was added
                placeProfileStore.testsTaken.splice(noneIndex, 1)
                placeProfileStore.testsTakenDBName.splice(noneIndexDB, 1)
            }
            if (index > -1) {
                // An item that was checked should be unchecked
                placeProfileStore.testsTaken.splice(index, 1)
                placeProfileStore.testsTakenDBName.splice(index, 1)
            } else {
                // We have a newly checked item To add to the lists of taken tests
                placeProfileStore.testsTaken.push(test.name)
                placeProfileStore.testsTakenDBName.push(test.dbName)
            }
        } else {
            // None is the selected test =>  delete all others
            placeProfileStore.testsTaken = []
            placeProfileStore.testsTakenDBName = []
            placeProfileStore.testsTaken.push(test.name)
            placeProfileStore.testsTakenDBName.push(test.dbName)
        }

        // Below is what gets stored to the DB
        this.setState({testsTaken: placeProfileStore.testsTakenDBName})
    }

    handleRadioChange = (value: string) => {
        // Let's use checkboxes so thing look right
        const profile: Profile = this.state.profile
        if (value === "Yes") {
            profile.familySpeaksOtherLanguage = true
            placeProfileStore.radioButtonValue = ["Yes"]
        } else if (value === "No") {
            profile.familySpeaksOtherLanguage = false
            placeProfileStore.radioButtonValue = ["No"]
        }
        this.setState({profile})
    }

    handleFamilySpeaksOtherLanguageChange(e: any) {
        const profile: Profile = this.state.profile
        profile.familySpeaksOtherLanguage = e.target.value.toLowerCase() === "yes"
        this.setState({profile})
    }

    handleFamilyMemberChange(value: string) {
        const profile: Profile = this.state.profile
        const familyMembers = placeProfileStore.familyMembersSelected
        let otherFamilyMember = placeProfileStore.otherFamilyMembersSelected
        const index: number = familyMembers.indexOf(value)
        if (index > -1) {
            familyMembers.splice(index, 1)

            if (otherFamilyMember.length > 0) {
                otherFamilyMember = ""
            }
        } else {
            familyMembers.push(value)
        }
        profile.familyMembers = familyMembers
        profile.otherFamilyMember = otherFamilyMember
        this.setState({profile})
    }

    handleFamilyMemberOtherChange(e: any) {
        const profile: Profile = this.state.profile
        profile.otherFamilyMember = e.target.value
        this.setState({profile})
    }

    validate(profile: Profile): { hasErrors: boolean; formErrors: FormErrors } {
        const formErrors: FormErrors = {
            firstName: this.getFirstNameErrors(profile),
            lastName: this.getLastNameErrors(profile),
            testTakerId: this.getTestTakerIdErrors(profile),
            confirmTestTakerId: this.getConfirmTestTakerIdErrors(profile),
            testTakerEmail: this.getTestTakerEmailErrors(profile),
            testsTaken: this.getTestsTakenErrors(profile),
            familySpeaksOtherLanguage: this.getFamilySpeaksOtherLanguageErrors(profile),
            yearsStudyingOrSpoken: this.getYearsStudyingOrSpokenyearsStudyingOrSpoken(profile),
            gradesStudiedIn: this.getGradesStudiedInErrors(profile),
            familyLanguage: this.getFamilyLanguageErrors(profile),
            familyMembers: this.getFamilyMembersErrors(profile),
            otherFamilyMember: []
        }

        let hasErrors: boolean = false
        Object.keys(formErrors).forEach((key: string) => {
            const value: string[] = formErrors[key]
            if (value && value.length > 0) {
                hasErrors = true
            }
        })

        return {
            hasErrors,
            formErrors
        }
    }

    getFirstNameErrors(profile: Profile): string[] {
        if (isNullOrUndefined(profile.firstName) || profile.firstName.length === 0) {
            return ["Please enter your first name."]
        }
        return []
    }

    getLastNameErrors(profile: Profile): string[] {
        if (isNullOrUndefined(profile.lastName) || profile.lastName.length === 0) {
            return ["Please enter your last name."]
        }
        return []
    }

    getTestTakerIdErrors(profile: Profile): string[] {
        if (isNullOrUndefined(profile.testTakerId) || profile.testTakerId.length === 0) {
            return ["Please enter your test taker id."]
        }
        return []
    }

    getConfirmTestTakerIdErrors(profile: Profile): string[] {
        const confirmTestTakerId = this.state.confirmTestTakerId
        const testTakerId = profile.testTakerId
        if (isNullOrUndefined(confirmTestTakerId) || confirmTestTakerId.length === 0) {
            return ["Please confirm your test taker id."]
        }
        if (confirmTestTakerId !== testTakerId) {
            return ["Your test taker id and test taker id confirmation must match."]
        }
        return []
    }

    getTestTakerEmailErrors(profile: Profile): string[] {
        if (isNullOrUndefined(profile.testTakerEmail) || profile.testTakerEmail.length === 0) {
            return ["Please enter your test taker email."]
        } else if (!validateEmail(profile.testTakerEmail)) {
            return ["Please enter a valid email address."]
        }
        return []
    }

    getTestsTakenErrors(profile: Profile): string[] {
        if (this.state.testsTaken.length === 0) {
            return ["Please select at least one option."]
        }
        return []
    }

    getFamilySpeaksOtherLanguageErrors(profile: Profile): string[] {
        if (profile.familySpeaksOtherLanguage === undefined) {
            return ["Please select an option."]
        }
        return []
    }

    getYearsStudyingOrSpokenyearsStudyingOrSpoken = (profile: Profile): string[] => {
        if (profile.yearsStudyingOrSpoken === "") {
            return ["Please choose an option."]
        }
        return []
    }

    getGradesStudiedInErrors = (profile: Profile): string[] => {
        if (profile.gradesStudiedIn === undefined || profile.gradesStudiedIn.length === 0) {
            return ["Please select at least one option."]
        }
        return []
    }

    getFamilyLanguageErrors = (profile: Profile): string[] => {
        if (profile.familySpeaksOtherLanguage && profile.familyLanguage === -1) {
            return ["Please select at least one option."]
        }
        return []
    }

    getFamilyMembersErrors = (profile: Profile): string[] => {
        if (profile.familySpeaksOtherLanguage && profile.familyMembers && profile.familyMembers.length === 0) {
            return ["Please select at least one option."]
        } else if (profile.familySpeaksOtherLanguage && profile.familyMembers) {
            const hasOther =
                profile.familyMembers.findIndex((familyMember: string) => familyMember.toLowerCase() === "other") !== -1
            if (hasOther && !isNullOrUndefined(profile.otherFamilyMember) && profile.otherFamilyMember.length === 0) {
                return ["Please enter the other family member you selected."]
            }
        }
        return []
    }

    getLanguageConfidenceErrors = (profile: Profile): string[] => {
        if (profile.languageConfidence === "") {
            return ["Please select at least one option."]
        }
        return []
    }

    handleSubmit() {
        this.setState({
            formError: null,
            formErrors: {
                firstName: [],
                lastName: [],
                testTakerId: [],
                confirmTestTakerId: [],
                testTakerEmail: [],
                testsTaken: [],
                yearsStudyingOrSpoken: [],
                gradesStudiedIn: [],
                familySpeaksOtherLanguage: [],
                familyLanguage: [],
                familyMembers: [],
                otherFamilyMember: []
            }
        })
        if (this.props.take === null) {
            this.setState({
                error: SUPPORT_MESSAGE
            })
            return
        }

        const errors = this.validate(this.state.profile)
        if (errors.hasErrors) {
            this.setState({
                formError: "There are errors on the form.",
                formErrors: errors.formErrors
            })
            return
        }

        // Converts the test scores into an array of test db name, score pairs
        const testsTaken: string[][] = []
        if (this.state.profile.testsTaken) {
            this.state.testsTaken.forEach((test: string) => {
                if (test !== "none") {
                    testsTaken.push([test, ""])
                }
            })
        }
        const profile = this.state.profile
        profile.testsTaken = testsTaken

        if (
            profile.contentAreaId === -1 ||
            profile.userId === -1 ||
            isNullOrUndefined(profile.takeCode) ||
            profile.takeCode.length === 0
        ) {
            this.setState({
                error: SUPPORT_MESSAGE
            })
            throw new Error(`PLACE profile is invalid.`)
        } else {
            log.debug(`[handleSubmit] About to post profile`, profile)
            const productName: string = productStore.driver!!.config.APP_PRODUCT_NAME.toLowerCase()
            ApiService.postProfile(new TakeId(this.props.take.id), profile, productName).then(
                () => {
                    this.props.profileSuccessDispatch(profile)
                    this.props.history.push("/self-evaluation")
                },
                (err: ApiErrorResponse) => {
                    if (err.response.data.errors) {
                        const formErrors = err.response.data.errors
                        this.setState({
                            formError: "There are errors on the form.",
                            formErrors
                        })
                    } else {
                        this.setState({
                            error: SUPPORT_MESSAGE
                        })
                        throw new Error(err.message)
                    }
                }
            )
        }
    }

    closeModal() {
        this.setState({showModal: false})
    }

    renderForm = () => {
        const {panelGraph} = this.props
        const {formError, formErrors} = this.state
        const testLanguage: string = contentAreaStore.convertContentAreaIdToLanguageName(panelGraph.contentAreaId)

        return (
            <form className="profile-form content-container" style={{margin: 0}}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h5" color="primary">
                            CREATE PROFILE
                        </Typography>
                        <Typography fontWeight="bold" mt={1}>
                            *Required
                        </Typography>
                    </Grid>

                    {/* Left Column */}
                    <Grid item sm={6} xs={12}>
                        {/* First Name */}
                        <FormControl fullWidth margin="normal" error={!!formError && formErrors.firstName.length > 0}>
                            <FormLabel>First Name*</FormLabel>
                            <TextField
                                value={this.state.profile.firstName}
                                onChange={this.handleFirstNameChange}
                                inputProps={{
                                    "data-tst-id": "first-name",
                                    readOnly: productStore.loginProduct!!.rostered
                                }}
                            />
                            <FormHelperText>{formErrors.firstName.join(" ")}</FormHelperText>
                        </FormControl>

                        {/* Last Name */}
                        <FormControl fullWidth margin="normal" error={!!formError && formErrors.lastName.length > 0}>
                            <FormLabel>Last Name*</FormLabel>
                            <TextField
                                value={this.state.profile.lastName}
                                onChange={this.handleLastNameChange}
                                inputProps={{
                                    "data-tst-id": "last-name",
                                    readOnly: productStore.loginProduct!!.rostered
                                }}
                            />
                            <FormHelperText>{formErrors.lastName.join(" ")}</FormHelperText>
                        </FormControl>

                        {/* Years Studied/Spoken */}
                        <FormControl
                            fullWidth
                            margin="normal"
                            error={!!formError && formErrors.yearsStudyingOrSpoken.length > 0}
                        >
                            <FormLabel>{`How many years have you studied or spoken ${testLanguage}?*`}</FormLabel>
                            <Select
                                value={this.state.profile.yearsStudyingOrSpoken}
                                onChange={this.handleYearsStudyingOrSpokenChange}
                                inputProps={{"data-tst-id": "years-studied-or-spoken"}}
                            >
                                {PlaceProfileConstants.zeroToTwenty.map((num: string) => (
                                    <MenuItem key={num} value={num}>
                                        {num}
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>{formErrors.yearsStudyingOrSpoken.join(" ")}</FormHelperText>
                        </FormControl>

                        {/* Tests Taken */}
                        <FormControl
                            component="fieldset"
                            margin="normal"
                            error={!!formError && formErrors.testsTaken.length > 0}
                        >
                            <FormLabel component="legend">{`What tests have you taken in ${testLanguage}?*`}</FormLabel>
                            <FormGroup>
                                {PlaceProfileConstants.testList.map((test: string) => (
                                    <FormControlLabel
                                        key={test}
                                        control={
                                            <Checkbox
                                                checked={placeProfileStore.testsTaken.includes(test)}
                                                onChange={() => this.testsTakenCallBack(test)}
                                                tabIndex={0}
                                            />
                                        }
                                        label={test}
                                    />
                                ))}
                            </FormGroup>
                            <FormHelperText>{formErrors.testsTaken.join(" ")}</FormHelperText>
                        </FormControl>

                        {/* Family Language Question */}
                        <FormControl
                            component="fieldset"
                            margin="normal"
                            error={!!formError && formErrors.familySpeaksOtherLanguage.length > 0}
                        >
                            <FormLabel
                                component="legend">{`Does anyone in the individual's household/family speak a language other than English?*`}</FormLabel>
                            <FormGroup>
                                {PlaceProfileConstants.radioButonValues.map((val: string) => (
                                    <FormControlLabel
                                        key={val}
                                        control={
                                            <Checkbox
                                                checked={placeProfileStore.radioButtonValue.includes(val)}
                                                onChange={() => this.handleRadioChange(val)}
                                                tabIndex={0}
                                            />
                                        }
                                        label={val}
                                    />
                                ))}
                            </FormGroup>
                            <FormHelperText>{formErrors.familySpeaksOtherLanguage.join(" ")}</FormHelperText>
                        </FormControl>

                        {/* Conditional Family Language Info */}
                        {this.state.profile.familySpeaksOtherLanguage && (
                            <>
                                <FormControl
                                    fullWidth
                                    margin="normal"
                                    error={!!formError && formErrors.familyLanguage.length > 0}
                                >
                                    <FormLabel>What language?*</FormLabel>
                                    <Select
                                        value={this.state.profile.familyLanguage?.toString() || ""}
                                        onChange={this.handleLanguageChange}
                                        inputProps={{"data-tst-id": "family-language"}}
                                        tabIndex={0}
                                    >
                                        {PlaceProfileConstants.languages
                                            .filter((lang) => lang.name !== "English")
                                            .map((language: IProfileLanguage) => (
                                                <MenuItem key={language.name} value={language.contentAreaId}>
                                                    {language.name}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                    <FormHelperText>{formErrors.familyLanguage.join(" ")}</FormHelperText>
                                </FormControl>

                                <FormControl
                                    component="fieldset"
                                    margin="normal"
                                    error={!!formError && formErrors.familyMembers.length > 0}
                                >
                                    <FormLabel>Identify who*</FormLabel>
                                    <FormGroup>
                                        {PlaceProfileConstants.familyMembers.map((member: string) => (
                                            <FormControlLabel
                                                key={member}
                                                control={
                                                    <Checkbox
                                                        checked={placeProfileStore.familyMembersSelected.includes(
                                                            member
                                                        )}
                                                        onChange={() => this.handleFamilyMemberChange(member)}
                                                        tabIndex={0}
                                                    />
                                                }
                                                label={member}
                                            />
                                        ))}
                                        {placeProfileStore.familyMembersSelected.includes("Other") && (
                                            <TextField
                                                fullWidth
                                                placeholder=""
                                                value={this.state.profile.otherFamilyMember}
                                                onChange={this.handleFamilyMemberOtherChange}
                                                inputProps={{"data-tst-id": "other-family-member"}}
                                                margin="dense"
                                            />
                                        )}
                                    </FormGroup>
                                    <FormHelperText>{formErrors.familyMembers.join(" ")}</FormHelperText>
                                </FormControl>
                            </>
                        )}
                    </Grid>

                    {/* Right Column */}
                    <Grid item sm={6} xs={12}>
                        {/* Test Taker ID */}
                        <FormControl fullWidth margin="normal" error={!!formError && formErrors.testTakerId.length > 0}>
                            <FormLabel>Test Taker ID*</FormLabel>
                            <TextField
                                value={this.state.profile.testTakerId}
                                onChange={this.handleTestTakerIdChange}
                                inputProps={{
                                    "data-tst-id": "student-id",
                                    readOnly: productStore.loginProduct!!.rostered
                                }}
                            />
                            <FormHelperText>{formErrors.testTakerId.join(" ")}</FormHelperText>
                        </FormControl>

                        {/* Confirm ID */}
                        <FormControl
                            fullWidth
                            margin="normal"
                            error={!!formError && formErrors.confirmTestTakerId.length > 0}
                        >
                            <FormLabel>Confirm Test Taker ID*</FormLabel>
                            <TextField
                                value={this.state.confirmTestTakerId}
                                onChange={this.handleConfirmTestTakerIdChange}
                                inputProps={{
                                    "data-tst-id": "confirm-student-id",
                                    readOnly: productStore.loginProduct!!.rostered
                                }}
                            />
                            <FormHelperText>{formErrors.confirmTestTakerId.join(" ")}</FormHelperText>
                        </FormControl>

                        {/* Email */}
                        <FormControl
                            fullWidth
                            margin="normal"
                            error={!!formError && formErrors.testTakerEmail.length > 0}
                        >
                            <FormLabel>Email*</FormLabel>
                            <TextField
                                value={this.state.profile.testTakerEmail}
                                onChange={this.handleEmailChange}
                                inputProps={{"data-tst-id": "email"}}
                            />
                            <FormHelperText>{formErrors.testTakerEmail.join(" ")}</FormHelperText>
                        </FormControl>

                        {/* Grades Studied */}
                        <FormControl component="fieldset" margin="normal">
                            <FormLabel>{`In what grades have you formerly studied ${testLanguage}?*`}</FormLabel>
                            <FormGroup>
                                {PlaceProfileConstants.grades.map((grade: string) => (
                                    <FormControlLabel
                                        key={grade}
                                        control={
                                            <Checkbox
                                                checked={placeProfileStore.gradesStudied.includes(grade)}
                                                onChange={() => this.changHandlerForGradesStudied(grade)}
                                                tabIndex={0}
                                            />
                                        }
                                        label={grade}
                                    />
                                ))}
                            </FormGroup>
                        </FormControl>
                    </Grid>

                    {/* Submit */}
                    <Grid item xs={12} style={{marginTop: 16}}>
                        {formError && (
                            <Typography color="error" align="center">
                                {formError}
                            </Typography>
                        )}
                        <Grid container justifyContent="center" mt={2}>
                            <Button
                                className="avant-button--default avant-button--primary"
                                block={false}
                                testId="submit"
                                onClick={this.handleSubmit}
                            >
                                SUBMIT
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        )
    }

    render() {
        const {error, take} = this.state

        return (
            <Container maxWidth="md" className="profile-form-container">
                {error && (
                    <Alert
                        severity="error"
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => this.setState({error: false})}
                            >
                                <CloseIcon fontSize="inherit"/>
                            </IconButton>
                        }
                        sx={{mb: 2}}
                    >
                        <AlertTitle>Error</AlertTitle>
                        {error}
                    </Alert>
                )}

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {take && (
                            <Card>
                                <CardContent>{this.renderForm()}</CardContent>
                            </Card>
                        )}
                    </Grid>
                </Grid>
            </Container>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlaceProfileFormContainer)
